/* src/app/components/payroll/timesheets/timesheet-filter/timesheet-filter.component.css */
.search {
  display: flex;
  justify-content: end;
}
.ant-form-item {
  margin-bottom: 24px !important;
}
input::placeholder {
  color: rgb(217, 217, 217) !important;
}
::ng-deep .ant-picker-input > input {
  border: none;
}
/*# sourceMappingURL=timesheet-filter.component-JIZLWOYZ.css.map */
